import { logger } from 'v2/utils/logger'
import { errorToast } from 'v2/utils/toasts'

// Navigate to an SSO URL hodor returned. Only https is ever followed; anything else is reported.
export const redirectToSso = (url?: string): void => {
  let parsed: URL | undefined
  try {
    parsed = new URL(url ?? '')
  } catch {}
  if (parsed?.protocol === 'https:') {
    window.location.href = parsed.href
    return
  }
  logger.error('SSO redirect rejected: non-https URL', url?.split(':')[0])
  errorToast({
    title: 'Sign-in error',
    description: 'Received an invalid single sign-on redirect. Please try again.',
  })
}
